import {
  CashTransferStatus,
  Player,
  AdditionDeductionTransactionType,
  PendingAdditionWithdrawal,
  PlayersFilterField,
} from '@/generated/graphql';
import { IUser, mapGQLUser } from './user';
import { ICashier, mapGQLCashier } from './cashier';

export interface IPlayer {
  id: string;
  firstName: string;
  lastName: string;
  contactNumber: string;
  createdAt: string;
  updatedAt: string;

  user: IUser;
  balance: number;
}

export interface IPlayerTable {
  id: string;
  name: string;
  contactNumber: string;
  username: string;
  createdAt: string;
  balanceFormatted: string;
  isDisabled: boolean;
}

export interface IPendingAdditionWithdrawal {
  id: string;
  amount: number;
  createdAt: string;
  type: string;
  referenceId: string;
  transactionType: string;
  notes: string;
  status: CashTransferStatus;
  senderAccountNumber: string;
  receiverAccountNumber: string;

  player: IPlayer;
  cashier: ICashier;
}

export interface IPlayerQueryVariable {
  first: number;
  after?: string;
  before?: string;
  filterBy?: PlayersFilterField;
}

export interface IPendingTransaction {
  id: string;
  amount: number;
  createdAt: string;
  type: string;
  referenceId: string;
  transactionType: string;
  notes: string;
  senderAccountNumber: string;
  receiverAccountNumber: string;

  playerName: string;
  cashierName: string;
  cashierId: string;
}

export interface IConfirmTransactionInput {
  id: string;
  notes: string;
  referenceId: string;
  senderAccountNumber: string;
  receiverAccountNumber: string;

  // ADDITIONAL INFO FOR DISPLAY
  playerName: string;
  transactionType: string;
  amountDisplay: string;
}

export function mapGQLPendingAdditionWithdrawal(gql_pending?: PendingAdditionWithdrawal | null): IPendingAdditionWithdrawal {
  return {
    id: gql_pending?.id ?? '',
    amount: gql_pending?.amount ?? 0,
    createdAt: gql_pending
      ? new Date(gql_pending.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
    type: gql_pending?.type ?? '',
    referenceId: gql_pending?.referenceId ?? '',
    transactionType: gql_pending?.transactionType ?? '',
    notes: gql_pending?.notes ?? '',
    status: gql_pending?.status ?? CashTransferStatus.Pending,
    player: mapGQLPlayer(gql_pending?.player),
    cashier: mapGQLCashier(gql_pending?.cashier),

    senderAccountNumber: gql_pending?.senderAccountNumber ?? '',
    receiverAccountNumber: gql_pending?.receiverAccountNumber ?? '',
  };
}

export function mapGQLPlayer(gql_player?: Player | null): IPlayer {
  return {
    id: gql_player?.id ?? '',
    firstName: gql_player ? gql_player.firstName ?? '' : '',
    lastName: gql_player ? gql_player.lastName ?? '' : '',
    contactNumber: gql_player ? gql_player.contactNumber ?? '' : '',
    balance: gql_player ? gql_player.balance ?? 0 : 0,

    updatedAt: gql_player ? gql_player.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    user: mapGQLUser(gql_player?.user),
    createdAt: gql_player
      ? new Date(gql_player.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
